export default __webpack_public_path__ + "static/media/simpleServo.96618747.svg";